import { BasketballLeaguesSlice, ModalsSlice } from '@hefe/store';
import { Button, Divider, Space, Steps } from 'antd';
import dayjs from 'dayjs';
import { t } from '@hefe/i18n';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import AddLeagueAssistentCountry from './add-league-assistent-country.component';
import AddLeagueAssistentLeagueSelection from './add-league-assistent-league-selection.component';
import AddLeagueAssistentPreview from './add-league-assistent-preview';
import AddLeagueAssistentSettings from './add-league-assistent-settings';
import AddLeagueAssistentTeamSelection from './add-league-assistent-team-selection.component';

export default function AddLeagueAssistent() {
  const dispatch = useAppDispatch();

  const [saveLeague, setSaveLeague] = useState(false);

  const assistent = useSelector(
    BasketballLeaguesSlice.basketballLeagueAssistentSelector
  );

  const currentStep = () => {
    switch (assistent.currentStep) {
      case 0:
        return <AddLeagueAssistentCountry />;
      case 1:
        return <AddLeagueAssistentLeagueSelection />;
      case 2:
        return <AddLeagueAssistentTeamSelection />;
      case 3:
        return <AddLeagueAssistentSettings />;
      case 4:
        return <AddLeagueAssistentPreview />;
      default:
        return;
    }
  };

  const isNextButtonDisabled = () => {
    switch (assistent.currentStep) {
      case 0:
        return !assistent.selectedCountry;
      case 1:
        return !assistent.selectedLeague;
      case 2:
        return (
          assistent.selectedTeams.length === 0 ||
          !assistent.selectedTeams[0].team_id ||
          !assistent.selectedTeams[0].season_team_id
        );
      case 3:
        return false;
      case 4:
        return false;
    }
    return true;
  };

  const buttonNextText = () => {
    if (assistent.currentStep === 4) {
      return t('save');
    } else {
      return t('next');
    }
  };

  const onClickNext = () => {
    // Preview -> store League
    if (assistent.currentStep === 4) {
      const selectedLeague = assistent.selectedLeague;
      if (selectedLeague) {
        setSaveLeague(true);
        const leagueSettings = assistent.settings;
        const leagueTeams = assistent.selectedTeams;
        dispatch(
          BasketballLeaguesSlice.createDbbBasketballLeague({
            league_id: selectedLeague.ligaId,
            league_name: selectedLeague.liganame,
            own_referees: leagueSettings.ownReferees,
            season_id: selectedLeague.seasonId || dayjs().year(),
            teams: leagueTeams.map((t) => {
              return {
                season_team_id: t.season_team_id || 0,
                team_id: t.team_id,
                name: t.label,
              };
            }),
          })
        )
          .unwrap()
          .then(() => {
            dispatch(ModalsSlice.modalsActions.closeModal());
          })
          .finally(() => setSaveLeague(false));
      }
    } else {
      dispatch(BasketballLeaguesSlice.basketballLeaguesActions.incrementStep());
    }
  };

  const onClickBack = () => {
    dispatch(BasketballLeaguesSlice.basketballLeaguesActions.decrementStep());
  };

  return (
    <Space size={24} direction="vertical" style={{ width: '100%' }}>
      <Steps current={assistent.currentStep} size="small">
        <Steps.Step title={t('leagues.assistant.select_country.title')} />
        <Steps.Step title={t('leagues.assistant.select_league.title')} />
        <Steps.Step title={t('leagues.assistant.select_teams.title')} />
        <Steps.Step title={t('leagues.assistant.settings.title')} />
        <Steps.Step title={t('leagues.assistant.check.title')} />
      </Steps>
      <Divider />
      {currentStep()}
      <Space style={{ float: 'right' }} direction="horizontal">
        <Button
          disabled={assistent.currentStep < 1}
          onClick={() => onClickBack()}
        >
          {t('prev')}
        </Button>
        <Button
          disabled={isNextButtonDisabled()}
          loading={saveLeague}
          onClick={() => onClickNext()}
        >
          {buttonNextText()}
        </Button>
      </Space>
    </Space>
  );
}
